import { Loader2 } from "lucide-react";

interface CenteredLoadingProps {
  message?: string;
  className?: string;
}

export function CenteredLoading({ message, className }: CenteredLoadingProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={
        "flex min-h-[60vh] w-full flex-col items-center justify-center gap-3 " +
        (className ?? "")
      }
    >
      <Loader2
        className="text-primary size-10 animate-spin motion-reduce:animate-none"
        aria-hidden="true"
      />
      <p className="text-muted-foreground text-sm">
        {message ?? "読み込み中…"}
      </p>
    </div>
  );
}
